export const commonFR = require("./commonFR.json");
export const pagesFR = require("./pagesFR.json");
export const messagesFR = require("./messagesFR.json");
